import React, { useEffect, useState } from "react";
import { useUpdateServiceMasterMutation } from "../../../Services/inventory/Inventory";
import { Loader } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";
import {
  useGetAllBrandDataQuery,
  useGetAllFuelTypeDataQuery,
  useGetAllServiceDataQuery,
  useGetIdModelDataQuery,
  useGetSubServiceOnIdBasisDataQuery,
} from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../../vehicle/ThemeColors";

interface IPROPS {
  closeModal: any;
  refetch: any;
  storeValue: any;
}

const EditServiceMaster: React.FC<IPROPS> = ({
  closeModal,
  refetch,
  storeValue,
}) => {
  const [laborCost, setLaborCost] = useState<any>(storeValue?.labour_cost);
  const [price, setPrice] = useState<any>(storeValue?.price);
  const [modelId, setModelId] = useState<any>(storeValue?.model);
  const [brandId, setBrandId] = useState<any>(storeValue?.brand);
  const [fuelTypeId, setFuelTypeId] = useState<any>(storeValue?.fuel_type);
  const [serviceTypeId, setServiceTypeId] = useState<any>(
    storeValue?.service_type
  );
  const [subServiceTypeId, setSubServiceTypeId] = useState<any>(
    storeValue?.sub_service_type
  );

  const [desc, setDesc] = useState(storeValue?.desc);

  const [vehicleTableData, setVehicleTableData] = useState([]);
  const [carModelData, setCarModelData] = useState([]);
  const [fuelTableData, setFuelTableData] = useState([]);
  const [serviceTableData, setServiceTableData] = useState([]);
  const [subServiceTableData, setSubServiceTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [updateServiceMasterTrigger, { status: updateStatus }] =
    useUpdateServiceMasterMutation();

  useEffect(() => {
    setLoading(updateStatus === "pending");
  }, [updateStatus]);

  const { data: vehicleData } = useGetAllBrandDataQuery({});
  const { data: modelData } = useGetIdModelDataQuery(brandId);
  const { data: fuelData } = useGetAllFuelTypeDataQuery({});
  const { data: serviceData } = useGetAllServiceDataQuery({});
  const { data: subServiceData } =
    useGetSubServiceOnIdBasisDataQuery(serviceTypeId);

  useEffect(() => {
    if (vehicleData) {
      if (Array.isArray(vehicleData)) {
        setVehicleTableData(vehicleData);
      } else if (vehicleData?.results) {
        setVehicleTableData(vehicleData.results);
      } else {
        setVehicleTableData([]);
      }
    }
  }, [vehicleData]);

  useEffect(() => {
    if (modelData) {
      if (Array.isArray(modelData)) {
        setCarModelData(modelData);
      } else if (modelData?.results) {
        setCarModelData(modelData.results);
      } else {
        setCarModelData([]);
      }
    }
  }, [modelData]);

  useEffect(() => {
    if (fuelData) {
      if (Array.isArray(fuelData)) {
        setFuelTableData(fuelData);
      } else if (fuelData?.results) {
        setFuelTableData(fuelData.results);
      } else {
        setFuelTableData([]);
      }
    }
  }, [fuelData]);

  useEffect(() => {
    if (serviceData) {
      if (Array.isArray(serviceData)) {
        setServiceTableData(serviceData);
      } else if (serviceData?.results) {
        setServiceTableData(serviceData.results);
      } else {
        setServiceTableData([]);
      }
    }
  }, [serviceData]);

  useEffect(() => {
    if (subServiceData) {
      if (Array.isArray(subServiceData)) {
        setSubServiceTableData(subServiceData);
      } else if (subServiceData?.results) {
        setSubServiceTableData(subServiceData.results);
      } else {
        setSubServiceTableData([]);
      }
    }
  }, [subServiceData]);

  const saveConsentMaster = async () => {
    const payload = {
      workshop: storeValue?.workshop,
      brand: brandId,
      model: modelId,
      fuel_type: fuelTypeId,
      service_type: serviceTypeId,
      sub_service_type: subServiceTypeId,
      labour_cost: laborCost,
      price: price,
      description: desc,
    };
    const response = await updateServiceMasterTrigger({
      body: payload,
      id: storeValue?.id,
    });

    try {
      if (response?.data) {
        closeModal();
        toast.success("Service updated successfully");
        refetch();
      } else if (response?.error) {
        toast.error("An error occurred");
      }
    } catch (error) {
      toast.error("An error occurred");
    }
  };

  const { selectedButtonBackgoundColors, selectedButtonColors } =
    useThemeColors();

  return (
    <div>
      <div className="vehicle-info-middle">
        <div
          className="vehicle-info"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "10px 15px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "10px",
              padding: "10px 30px",
            }}
          >
            {/* Brand */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                  }}
                >
                  Brand
                </span>
                <span>
                  <select
                    value={brandId}
                    onChange={(e) => setBrandId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                  >
                    <option style={{ fontFamily: "karbon", color: "#666666" }}>
                      Select an option
                    </option>
                    {vehicleTableData &&
                      vehicleTableData.map((brand: any) => (
                        <option
                          key={brand.id}
                          value={brand.id}
                          style={{ fontFamily: "karbon", color: "#666666" }}
                        >
                          {brand.name}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>
            {/* Model */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                    fontWeight: 200,
                  }}
                >
                  Model
                </span>
                <span>
                  <select
                    disabled={!brandId}
                    value={modelId}
                    onChange={(e) => setModelId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                  >
                    <option style={{ fontFamily: "karbon", color: "#666666" }}>
                      Select an option
                    </option>
                    {carModelData &&
                      carModelData.map((model: any) => (
                        <option
                          key={model.id}
                          value={model.id}
                          style={{ fontFamily: "karbon", color: "#666666" }}
                        >
                          {model?.name}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>
            {/* Fuel type */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                  }}
                >
                  Fuel type
                </span>
                <span>
                  <select
                    value={fuelTypeId}
                    onChange={(e) => setFuelTypeId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                  >
                    <option style={{ fontFamily: "karbon", color: "#666666" }}>
                      Select an option
                    </option>
                    {fuelTableData &&
                      fuelTableData.map((fuelType: any) => (
                        <option
                          key={fuelType.id}
                          value={fuelType.id}
                          style={{ fontFamily: "karbon", color: "#666666" }}
                        >
                          {fuelType.type}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>
            {/* Service type */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                  }}
                >
                  Service type
                </span>
                <span>
                  <select
                    value={serviceTypeId}
                    onChange={(e) => setServiceTypeId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                  >
                    <option style={{ fontFamily: "karbon", color: "#666666" }}>
                      Select an option
                    </option>
                    {serviceTableData &&
                      serviceTableData.map((service: any) => (
                        <option
                          key={service.id}
                          value={service.id}
                          style={{ fontFamily: "karbon", color: "#666666" }}
                        >
                          {service.name}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>
            {/* Sub service */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                  }}
                >
                  Sub service
                </span>
                <span>
                  <select
                    value={subServiceTypeId}
                    onChange={(e) => setSubServiceTypeId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                  >
                    <option style={{ fontFamily: "karbon", color: "#666666" }}>
                      Select an option
                    </option>
                    {subServiceTableData &&
                      subServiceTableData.map((subService: any) => (
                        <option
                          key={subService.id}
                          value={subService.id}
                          style={{ fontFamily: "karbon", color: "#666666" }}
                        >
                          {subService.name}
                        </option>
                      ))}
                  </select>
                </span>
              </p>
            </div>
            {/* Labor cost */}
            {/* <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                  }}
                >
                  Labor cost
                </span>
                <span>
                  <input
                    style={{
                      borderRadius: "20px",
                      background: "#FCFCFC",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                    className="form-control"
                    type="text"
                    onChange={(e) => setLaborCost(e.target.value)}
                    value={laborCost}
                    placeholder="Labor Cost"
                  />
                </span>
              </p>
            </div> */}
            {/* Price */}
            {/* <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                  }}
                >
                  Price
                </span>
                <span>
                  <input
                    style={{
                      borderRadius: "20px",
                      background: "#FCFCFC",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                    className="form-control"
                    type="text"
                    onChange={(e) => setPrice(e.target.value)}
                    value={price}
                    placeholder="Price"
                  />
                </span>
              </p>
            </div> */}
          </div>
          <div style={{ padding: "10px 30px" }}>
            <textarea
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
              placeholder="Enter Description"
              style={{
                width: "100%",
                borderRadius: "40px",
                padding: "10px 20px",
                background: "#FFF1EC",
                border: "none",
                fontFamily: "karbon",
                color: "#666666",
              }}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <button
              onClick={saveConsentMaster}
              style={{
                background: `${selectedButtonBackgoundColors}`,
                color: `${selectedButtonColors}`,
                border: "none",
                padding: "10px 20px",
                borderRadius: "20px",
                fontSize: "15px",
                fontFamily: "karbon",
              }}
            >
              {loading ? (
                <>
                  Saving...
                  <Loader />
                </>
              ) : (
                "Save"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditServiceMaster;
